export default "__VITE_ASSET__BSB7a_zG__"